'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

// ----------------------------------------
// Private
// ----------------------------------------

var contentString = '<div id="content">' +
	'<h4 class="contact__item-name">RESET2 Sp. z o.o. </h4>' +
	'<p>50-504 Wrocław ul. Jesionowa 23-25</p>' +
	'</div>';

function setPlace (latitude, longitude) {
	var place = new window.google.maps.LatLng(latitude, longitude);

	return place;
}

// ----------------------------------------
// Public
// ----------------------------------------

function initMap () {
	if ($('#map').length) {
		var location = {
			latitude: $('#map').data('lat'),
			longitude: $('#map').data('lng')
		};

		var infowindow = new window.google.maps.InfoWindow({
			content: contentString
		});

		var map = new window.google.maps.Map(document.getElementById('map'), {
			zoom: 15,
			center: setPlace(location.latitude, location.longitude),
			scrollwheel: false
		});

		var marker = new window.google.maps.Marker({
			position: setPlace(location.latitude, location.longitude),
			map: map,
			optimized: false,
			title: ''
		});

		infowindow.open(map, marker);

		window.google.maps.event.addListener(marker, 'click', function () {
			infowindow.open(map, marker);
			return false;
		});
	}
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {initMap};



// WEBPACK FOOTER //
// ./src/js/_modules/map.js